/**
 * Inyector aislado de meta tags en el <head>. Solo lectura/escritura de DOM:
 * no se engancha a axios/fetch ni al formulario de reserva.
 */

export interface SeoMetaPayload {
  title: string;
  description: string;
  canonicalUrl: string;
}

const SEO_MARKER = 'data-seo-host';

function upsertMeta(
  selector: string,
  attribute: 'name' | 'property',
  key: string,
  content: string,
): void {
  let el = document.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attribute, key);
    el.setAttribute(SEO_MARKER, 'meta');
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href: string): void {
  let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute(SEO_MARKER, 'meta');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
}

/**
 * Aplica título, meta description, canonical, Open Graph y Twitter para el
 * servicio. Es idempotente: reutiliza los nodos existentes (incluidos los que ya
 * sirvió el servidor) para no duplicar etiquetas.
 */
export function applySeoMeta(payload: SeoMetaPayload): void {
  const { title, description, canonicalUrl } = payload;

  document.title = title;

  upsertMeta('meta[name="description"]', 'name', 'description', description);
  upsertCanonical(canonicalUrl);

  upsertMeta('meta[property="og:title"]', 'property', 'og:title', title);
  upsertMeta('meta[property="og:description"]', 'property', 'og:description', description);
  upsertMeta('meta[property="og:url"]', 'property', 'og:url', canonicalUrl);

  upsertMeta('meta[name="twitter:title"]', 'name', 'twitter:title', title);
  upsertMeta('meta[name="twitter:description"]', 'name', 'twitter:description', description);
}

/** Elimina únicamente los nodos inyectados por este módulo (marcador data-seo-host). */
export function clearSeoServiceMeta(): void {
  document.querySelectorAll<HTMLElement>(`[${SEO_MARKER}="meta"]`).forEach((el) => el.remove());
}
